import { gql } from '@apollo/client'
import { Breadcrumb, Link } from '@farol-ds/react'
import { useMetrics } from '@jusbrasil-web/docview/core'
import { buildCanonicalSERPUrl } from '@jusbrasil-web/shared-search-canonical-url'
import { getJusbrasilBaseURL } from '@jusbrasil-web/shared-utils-url'

import { MotionBreadcrumb_DocumentFragment } from './__generated__/motion-breadcrumb.graphql'
import styles from './motion-breadcrumb.module.scss'

export interface MotionBreadcrumbProps {
  document: MotionBreadcrumb_DocumentFragment
}

export function MotionBreadcrumb(props: MotionBreadcrumbProps) {
  const { document } = props
  const activeSubject = document.lawsuit?.subjects?.[0]
  const parentSubjects = document.lawsuit?.mainSubject?.parents
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLOListElement>()

  if (!activeSubject || !parentSubjects?.length) {
    return null
  }

  const breadcrumbItems = parentSubjects?.map((parent) => {
    const subject = parent?.name || ''
    return {
      label: subject.toLowerCase(),
      url: parent?.name
        ? buildCanonicalSERPUrl({ path: '/pecas/busca', queryParams: { q: parent.name } })
        : '',
    }
  })

  const onItemClick = () => sendMetrics('Peca.LawsuitSubjectsBreadcrumbClicked')

  return (
    <Breadcrumb className={styles.container} ref={dispatcherRef} onClick={onItemClick}>
      <Breadcrumb.HomeItem />
      <Breadcrumb.Item>
        <Link type="primary" href={`${getJusbrasilBaseURL()}/pecas/`}>
          Peças Processuais
        </Link>
      </Breadcrumb.Item>
      {breadcrumbItems?.map((item, idx) => (
        <Breadcrumb.Item key={idx}>
          <Link type="primary" href={item.url}>
            {item.label}
          </Link>
        </Breadcrumb.Item>
      ))}
      {activeSubject && <Breadcrumb.Item>{activeSubject}</Breadcrumb.Item>}
    </Breadcrumb>
  )
}

MotionBreadcrumb.fragments = {
  document: gql`
    fragment MotionBreadcrumb_document on Document {
      lawsuit {
        subjects
        mainSubject {
          parents {
            name
          }
        }
      }
    }
  `,
}
